import { DocumentForm } from '../../../types';
import { Entity } from '../../../types/utility';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { DOCUMENTS_BASE_PATH } from '../constants/documentsBasePath';
import { buildHeadersFromDocumentParams } from '../logic/buildHeadersFromDocumentParams';
import { DocumentParams } from '../types/DocumentParams';

export const postDocumentFormAction = async (
  constructPost: ConstructPost,
  documentId: string,
  documentParams: DocumentParams,
  data: Entity,
  formIdentifier: string,
  action: string,
  path: string,
): Promise<NonPaginatedResponse<DocumentForm> | undefined> =>
  constructPost(
    `${DOCUMENTS_BASE_PATH}/${documentId}/formv2/action`,
    {
      data,
      params: { form: formIdentifier, action, path },
      headers: buildHeadersFromDocumentParams(documentParams),
    },
    { preventDefaultErrorToast: true },
  );
